import * as RecordRTC from 'recordrtc';
import * as lamejs from 'lamejs';

let recorder;
let audioContext;

declare var AudioContext, webkitAudioContext: any;

function str2ab(str) {
	var buf = new ArrayBuffer(str.length*2); // 2 bytes for each char
	var bufView = new Uint16Array(buf);
	for (var i=0, strLen=str.length; i < strLen; i++) {
	  bufView[i] = str.charCodeAt(i);
	}
	return buf;
  }

export default class Audio {

	recorder: any;
	audio: any;
	microphone: any;
	isSafari: boolean;

	record() {
		this.replaceAudio();

		this.audio.muted = true;
		this.setSrcObject(this.microphone, this.audio);
		this.audio.play();

		const options = {
			type: 'audio',
			mimeType: 'audio/wav',
			numberOfAudioChannels: 1,
			checkForInactiveTracks: true,
			bufferSize: 16384
		};

		if (navigator.platform && navigator.platform.toString().toLowerCase().indexOf('win') === -1) {
			(options as any).sampleRate = 44100; // or 44100 or remove this line for default
		}

		console.log("options are ", options)

		if (this.recorder) {
			this.recorder.destroy();
			this.recorder = null;
		}

		this.recorder = RecordRTC(this.microphone, options);

		this.recorder.startRecording();
	}

	stop(cb: (mp3Audio: Blob, wavAudio: Blob) => void ) {
		this.recorder.stopRecording(() => {
			let blob = this.recorder.getBlob();

			if (this.isSafari) {
				const fr = new FileReader();
				fr.readAsArrayBuffer(blob);

				fr.onload = () => {
					console.log("RESULT IS ", fr.result as ArrayBuffer);
					const mp3Blob: Blob = this.encodeMp3((typeof fr.result === 'string')? str2ab(fr.result) : fr.result);

					cb(mp3Blob, blob);

					if (this.microphone) {
						this.microphone.stop();
						this.microphone = null;
					}
				};
			} else {
				cb(blob, blob);
			}
		});
	}

	encodeMp3(arrayBuffer: ArrayBuffer) {
		const maxSamples: number = 1152;
		const dataBuffer = [];
		let mp3buf;
		console.log(arrayBuffer);
		const wav = lamejs.WavHeader.readHeader(new DataView(arrayBuffer));
		if (!wav) {
			console.log('Specified file is not a Wave file');
			return;
		}

		console.log('---------', wav.dataOffset, wav.dataLen);
		let samples = new Int16Array(arrayBuffer, wav.dataOffset, wav.dataLen / 2);

		console.log("CHANNELS ", wav.channels);

		const mp3Encoder = new lamejs.Mp3Encoder(wav.channels, wav.sampleRate, 96);

		for (let i = 0; i < samples.length; i += maxSamples) {
			let sampleArray = samples.subarray(i, i + maxSamples);

			mp3buf = mp3Encoder.encodeBuffer(sampleArray);
			dataBuffer.push(new Int8Array(mp3buf));
		}

		mp3buf = mp3Encoder.flush();
		dataBuffer.push(new Int8Array(mp3buf));

		return new Blob(dataBuffer);
	}

	init() {
		this.isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
		this.audio = document.querySelector('audio');
		this.captureMicrophone((mic) => {
			this.microphone = mic;

			if (this.isSafari) {
				this.replaceAudio();

				this.audio.muted = true;
				this.setSrcObject(this.microphone, this.audio);
				this.audio.play();
				return;
			}
			this.record();
		});
	}

	captureMicrophone = (callback: any) => {
		if (this.microphone) {
			callback(this.microphone);
			return;
		}

		if(navigator.mediaDevices && navigator.mediaDevices.getUserMedia){
			navigator.mediaDevices.getUserMedia({
				audio: true
			}).then((mic) => {
				callback(mic);
			}).catch((error) => {
				alert('Unable to capture your microphone. Please check console logs.');
				console.error(error);
			});
		}else if(navigator.getUserMedia || (navigator as any).webkitGetUserMedia || (navigator as any).mozGetUserMedia) {

			navigator.getUserMedia = navigator.getUserMedia || (navigator as any).webkitGetUserMedia || (navigator as any).mozGetUserMedia;

			navigator.getUserMedia({
				audio: true
			},(mic) => {
				callback(mic);
			},(error) => {
				alert('Unable to capture your microphone. Please check console logs.');
				console.error(error);
			});
		}else{
			alert('This browser does not support autio recording');
		}
	}

	replaceAudio = (src?: any) => {
		let newAudio = document.createElement('audio');
		newAudio.controls = true;
		newAudio.id = 'replay';


		if (src) {
			newAudio.src = src;
		}

		let parentNode = document.getElementById('audioParent');
		parentNode.innerHTML = '';
		parentNode.appendChild(newAudio);

		this.audio = newAudio;
	}

	setSrcObject = (stream: any, element: any, ignoreCreateObjectURL?: any) => {
		if ('createObjectURL' in URL && !ignoreCreateObjectURL) {
			try {
				element.src = URL.createObjectURL(stream);
			} catch (e) {
				// this.setSrcObject(stream, element, true);
				return;
			}
		} else if ('srcObject' in element) {
			element.srcObject = stream;
		} else if ('mozSrcObject' in element) {
			element.mozSrcObject = stream;
		} else {
			alert('createObjectURL/srcObject both are not supported.');
		}
	}
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./react/src/containers/Play/audio.tsx